/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
// import { NbAuthComponent } from '@nebular/auth';
import { NgxAuthComponent } from "./auth.component";

import { LoginComponent } from "./login/login.component";
import { SignUpComponent } from "./sign-up/sign-up.component";
import { TwoFactorAuthComponent } from "./two-factor-auth/two-factor-auth.component";

export const routes: Routes = [
    {
        path: "",
        component: NgxAuthComponent,
        children: [
            {
                path: "login",
                component: LoginComponent,
            },
            {
                path: "autenticacao",
                component: TwoFactorAuthComponent,
            },
        ],
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class AuthRoutingModule {}
